import { ComponentSlotStyle } from '@fluentui/react-northstar';
import { getMaxHeight, mergeStyles, mergeStyleSets, getTheme, FontWeights } from '@fluentui/react';
import { IButtonStyles } from '@fluentui/react/lib/Button';

const theme = getTheme();
const StartScreenContainerStyle = mergeStyles({
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  // minHeight: '430px',
  maxHeight: '100%',
  minWidth:"800px",
  overflowY: 'hidden',
  overflowX:"hidden",
  // height: '2.125rem',
  display: 'flex',
  flexDirection: 'column'
  // alignItems: 'center'
});
const StartScreenSectionStyle = mergeStyles({
  flex: '1',
  height: '70%',
  // width:'100%',
  boxSizing:'border-box',
  // height:'100%',
  // marginTop:"49px",
  borderTop: '1px solid #E1DFDD'
});
const SideboxStyles = mergeStyles({
  // boxShadow:" inset  0px 1.2px 3.6px rgba(0, 0, 0, 0.03), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07)",
  width:'25%',
  height: '100%',
  maxWidth:"354px",
  minWidth:"200px",
  // borderLeft: '1px solid #E1DFDD',
  background: '#F0F0F0',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  // borderLeft:"1px solid #f0f0f0",
  boxShadow: 'inset 0px 5px 10px rgba(0, 0, 0, 0.09)'
  // boxShadow: '0px 1.2px 3.6px rgba(0, 0, 0, 0.03), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07)'
  // borderTop:'1px solid  #E1DFDD',
  // flex:'3'
});
const SideHeaderSerchStyle = mergeStyles({
  padding: '10px',
  boxSizing: 'border-box',
  background: '#F3F2F1',
  borderBottom: '1px solid rgb(225, 223, 221)',
  borderRadius: '0px 0px 2px 2px',
  height: '54px',
  // boxShadow: ' 0px 1.2px 3.6px rgba(0, 0, 0, 0.03), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07);'
});
const tabStyles = mergeStyles({
  margin: '0px',
  marginTop:"-22px",
  background: '#F0F0F0',
  height: '100%',
  '.ant-tabs-nav':{
    width:"20%",
    minWidth:"200px !important"
  },
  '.ant-tabs-nav-wrap': {
    // borderRight:"solid 1px  rgb(225, 223, 221)",
    // boxShadow: "0px 1.2px 3.6px rgba(0, 0, 0, 0.03), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07)",
   
    paddingTop: '52px',
    boxSizing: 'border-box'
  },
  '.ant-tabs-content .ant-tabs-content-left': {
    padding: '0',
    height: '100%'
  },
  '.ant-tabs-tabpane': {
    paddingLeft: '0',
    height: '100%'
  },
  '.antd-tabs': {  
    height: '100%'
  },
  '.ant-tabs-tab-active': {
    // boxShadow: 'inset -2px 0px 2px 0px rgba(0, 0, 0, 0.09)',
    background: '#FFFFFF',
    border: 'none'
  },
  '.ant-tabs-ink-bar': {
    background: 'none'
  },
  '.ant-tabs-tab:hover': {
    color: '#484644'
  },
  '.ant-tabs-tab': {
    height: '46px',
    padding: '6px,10px,6px,20px',
    margin: '0px',
  },
  '.ant-tabs-tab + .ant-tabs-tab': {
    marginTop: '0px !important',
  },
  '.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
    color: '#484644',
    width:"100% !important"
  }
});
const chatAvatarStyle = (isShow: boolean): ComponentSlotStyle => ({
  display: isShow ? 'block' : 'none',
  position: 'absolute',
  top: '8px',
  left: '40px'
});

const listcopybtnStyle = mergeStyles({
  width: '24px',
  height: '24px',
  background: '#6264A7',
  borderRadius: ' 4px',
  color: ' #FFFFFF',
  textAlign: 'center',
  lineHeight: '24px',
  fontSize: '8px',
  cursor: 'pointer'
});
const textHeaderStyle = mergeStyles({
  padding: '10px 38px 0 8px',
  boxSizing: 'border-box',
});
const textStyle = mergeStyles({
  color: '#242424',
  fontSize: '12px',
  fontWeight: '800'
});
const listLiStyle = mergeStyles({
  color: '#242424',
  fontSize: '14px',
  padding: '12px 24px 12px 44px',
  boxSizing: 'border-box',
  position: 'relative',
  ':after': {
    content: '',
    background: 'red',
    width: '8px',
    height: '8px',
    borderRadius: '100%',
    position: 'absolute',
    left: '0',
    top: '0'
  },
  ':hover': {
    background: '#ffffff',
    '.CopyIcon':{
      display:"block !important"
    }
  },
  marginTop: '4px'
});

const mt = mergeStyles({
  whiteSpace: 'pre-wrap',
  marginTop: '8px'
});
const quickSaveStyle = mergeStyles({
  margin: '17px 32px ',
  border: 'none',
  borderRadius: '4px',
  bottom: '0px',
  
  '.ms-TextField-fieldGroup': {
    border: 'none',
    minHeight:"0px",
    maxHeight:"300px",
    boxSizing:"border-box"
  }
});
const contentStyles = mergeStyleSets({
  containerLogPage: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    top:"0px"
  },
  containerMonitor: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    width: '75%',
    height: '80%',
    overflow: 'hidden',
  },
  SetupPage: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    width: '800px',
    height: '717px'
  },
  header: [
    theme.fonts.xLargePlus,
    {
      minHeight:"30px",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      alignItems: 'center',
      fontWeight: FontWeights.semibold
    }
  ],
  body: {
    width:"100%",
    maxheight:"90%",

    flex: '1',
    padding: '0 24px 0px 24px',
    height:"90%",
    overflowY: 'hidden',
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 }
    }
  }
});
const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};
export {
  StartScreenContainerStyle,
  StartScreenSectionStyle,
  SideboxStyles,
  SideHeaderSerchStyle,
  tabStyles,
  chatAvatarStyle,
  listcopybtnStyle,
  textStyle,
  listLiStyle,
  mt,
  iconButtonStyles,
  contentStyles,
  textHeaderStyle,
  quickSaveStyle
};
